// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item[data-v-799026e6]{transition:all .3s ease-out}.item .text-p[data-v-799026e6]{max-height:0;opacity:0;overflow:hidden;transition:height .5s ease-out}.item .item-desc[data-v-799026e6]{opacity:1;max-height:9999px}[data-v-799026e6] .contain-img img{max-height:452px;object-fit:contain}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
